module.exports = __webpack_public_path__ + "img/interior-design-of-a-house-1571460.37e6f9cf.jpg";